module.exports = __webpack_public_path__ + "img/zet-frame.23e08ef7.svg";